import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'sh-platform-input',
  templateUrl: './platform-input.component.html',
  styleUrl: './platform-input.component.scss',
  standalone: false
})
export class PlatformInputComponent implements OnInit {
  form = new FormGroup({
    firstName: new FormControl(null),
    lastName: new FormControl('Doe'),
    middleName: new FormControl(null, [Validators.required]),
    familyName: new FormControl(null)
  });

  import = `
    import {UiPlatformInputComponent} from 'ui-platform';
  `;

  usage = `
        <ui-platform-input
                formControlName="familyname"
                [label]="'Family name'"
                [placeholder]="'Enter text...'"
        >
        </ui-platform-input>
    `;

  constructor() {}

  ngOnInit(): void {
    this.form.controls.middleName.markAsTouched();
  }

  get middleNameError() {
    return this.form.controls['middleName'].touched && this.form.controls['middleName'].errors?.required;
  }
}
